export const CALENDLY_DEMO_LINK = process.env.VUE_APP_CALENDLY_DEMO_LINK;
export const CALENDLY_BUILD_LINK =
  process.env.VUE_APP_CALENDLY_BUILD_CONSULTATION_LINK;
export const CALENDLY_PROJECT_SALES_MARKETING_LINK =
  process.env.VUE_APP_CALENDLY_PROJECT_SALES_MARKETING_LINK;
